import React from 'react';
import { Group, Button, Text, Badge, ActionIcon, Tooltip, Box } from '@mantine/core';
import { Trash2, Edit, CheckCircle, XCircle, Download } from 'lucide-react';
interface BulkActionToolbarProps {
  selectedCount: number;
  onClearSelection: () => void;
  onBulkEdit?: () => void;
  onBulkDelete?: () => void;
  onBulkApprove?: () => void;
  onBulkReject?: () => void;
  onExport?: () => void;
}
export function BulkActionToolbar({
  selectedCount,
  onClearSelection,
  onBulkEdit,
  onBulkDelete,
  onBulkApprove,
  onBulkReject,
  onExport
}: BulkActionToolbarProps) {
  if (selectedCount === 0) {
    return <Group justify="space-between" p="md" style={{
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      backgroundColor: 'rgba(255, 255, 255, 0.04)'
    }} data-id="element-58">
        <Text size="sm" fw={600} style={{
        color: 'rgba(255, 255, 255, 0.5)'
      }} data-id="element-59">
          Select rows to perform bulk actions
        </Text>
        {onExport && <Button variant="light" size="sm" color="blue" leftSection={<Download size={16} data-id="element-61" />} onClick={onExport} styles={{
        root: {
          backgroundColor: 'rgba(59, 130, 246, 0.15)',
          border: '1px solid rgba(59, 130, 246, 0.2)',
          '&:hover': {
            backgroundColor: 'rgba(59, 130, 246, 0.25)'
          }
        }
      }} data-id="element-60">
            Export All
          </Button>}
      </Group>;
  }
  return <Group justify="space-between" p="md" style={{
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    backgroundColor: 'rgba(59, 130, 246, 0.1)'
  }} data-id="element-62">
      <Group gap="md" data-id="element-63">
        <Badge size="lg" variant="filled" color="blue" data-id="element-64">
          {selectedCount} selected
        </Badge>
        <Button variant="subtle" size="sm" onClick={onClearSelection} styles={{
        root: {
          color: '#60a5fa',
          '&:hover': {
            backgroundColor: 'rgba(59, 130, 246, 0.15)'
          }
        }
      }} data-id="element-65">
          Clear Selection
        </Button>
      </Group>

      <Group gap="xs" data-id="element-66">
        {onBulkEdit && <Tooltip label="Edit selected loans" data-id="element-67">
            <ActionIcon variant="light" color="blue" size="lg" onClick={onBulkEdit} style={{
          backgroundColor: 'rgba(59, 130, 246, 0.15)',
          border: '1px solid rgba(59, 130, 246, 0.2)'
        }} data-id="element-68">
              <Edit size={18} data-id="element-69" />
            </ActionIcon>
          </Tooltip>}
        {onBulkApprove && <Tooltip label="Approve selected loans" data-id="element-70">
            <ActionIcon variant="light" color="green" size="lg" onClick={onBulkApprove} style={{
          backgroundColor: 'rgba(34, 197, 94, 0.15)',
          border: '1px solid rgba(34, 197, 94, 0.2)'
        }} data-id="element-71">
              <CheckCircle size={18} data-id="element-72" />
            </ActionIcon>
          </Tooltip>}
        {onBulkReject && <Tooltip label="Reject selected loans" data-id="element-73">
            <ActionIcon variant="light" color="orange" size="lg" onClick={onBulkReject} style={{
          backgroundColor: 'rgba(249, 115, 22, 0.15)',
          border: '1px solid rgba(249, 115, 22, 0.2)'
        }} data-id="element-74">
              <XCircle size={18} data-id="element-75" />
            </ActionIcon>
          </Tooltip>}
        {onBulkDelete && <Tooltip label="Delete selected loans" data-id="element-76">
            <ActionIcon variant="light" color="red" size="lg" onClick={onBulkDelete} style={{
          backgroundColor: 'rgba(239, 68, 68, 0.15)',
          border: '1px solid rgba(239, 68, 68, 0.2)'
        }} data-id="element-77">
              <Trash2 size={18} data-id="element-78" />
            </ActionIcon>
          </Tooltip>}
        {onExport && <Button variant="light" size="sm" color="blue" leftSection={<Download size={16} data-id="element-80" />} onClick={onExport} styles={{
        root: {
          backgroundColor: 'rgba(59, 130, 246, 0.15)',
          border: '1px solid rgba(59, 130, 246, 0.2)',
          '&:hover': {
            backgroundColor: 'rgba(59, 130, 246, 0.25)'
          }
        }
      }} data-id="element-79">
            Export Selected
          </Button>}
      </Group>
    </Group>;
}